import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { useSettings } from "../context/SettingsContext";
import { Leaf } from "lucide-react";

export default function Header() {
  const { lang, setLang, t } = useLang();
  const { settings } = useSettings();

  return (
    <header className="glass fixed top-0 inset-x-0 z-40 border-b border-[color:var(--border)]/40">
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-[72px] flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2.5 group"
        >
          <span
            className="flex items-center justify-center w-9 h-9 rounded-full"
            style={{ background: "var(--primary)", color: "var(--primary-fg)" }}
          >
            <Leaf size={18} />
          </span>
          <span className="font-serif text-2xl leading-none tracking-tight">
            {lang === "mn" ? settings.site_title_mn || "Минимоду" : settings.site_title_en || "Minimodu"}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <NavLink to="/" data-testid="nav-home" className={({ isActive }) => isActive ? "font-semibold" : "opacity-70 hover:opacity-100"}>
            {t("nav_home")}
          </NavLink>
          <NavLink to="/gallery" data-testid="nav-gallery" className={({ isActive }) => isActive ? "font-semibold" : "opacity-70 hover:opacity-100"}>
            {t("nav_gallery")}
          </NavLink>
          <NavLink to="/booking" data-testid="nav-booking" className={({ isActive }) => isActive ? "font-semibold" : "opacity-70 hover:opacity-100"}>
            {t("nav_booking")}
          </NavLink>
          <NavLink to="/contact" data-testid="nav-contact" className={({ isActive }) => isActive ? "font-semibold" : "opacity-70 hover:opacity-100"}>
            {t("nav_contact")}
          </NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <div className="lang-pill" data-testid="lang-toggle">
            <button
              onClick={() => setLang("mn")}
              className={lang === "mn" ? "active" : ""}
              data-testid="lang-mn"
            >
              МН
            </button>
            <button
              onClick={() => setLang("en")}
              className={lang === "en" ? "active" : ""}
              data-testid="lang-en"
            >
              EN
            </button>
          </div>
          <Link to="/booking" className="btn btn-primary btn-sm hidden sm:inline-flex" data-testid="header-book-btn">
            {t("book_now")}
          </Link>
        </div>
      </div>
    </header>
  );
}
